<header class="navbar navbar-fixed-top bg-system">
    <ul class="nav navbar-nav navbar-left">
        <li class="hidden-xs">
            <a class="navbar-fullscreen toggle-active" href="/" ng-click="mainPage()">
                <img src="img/logo-blue.svg" alt="Hodxpress.com">
            </a>
        </li>
    </ul>

    <ul class="nav navbar-nav navbar-right">

        <li ng-class="{ active: isActive('profile')}">
            <a href="/profile">
                <span>Profile</span>
            </a>
        </li>

        <li ng-class="{ active: isActive('users')}">
            <a href="/users">
                <span>Users</span>
            </a>
        </li>

        <li ng-class="{ active: isActive('work-steps')}">
            <a href="/work-steps">
                <span>Sms/Mail Content</span>
            </a>
        </li>

        <!-- <li ng-class="{ active: isActive('sms-entegrasyonu')}" ng-if="authenticatedUser.type != 'office'">
            <a href="/sms-entegrasyonu">
                <i class="fa fa-envelope"></i>
                <span>Sms Sağlayıcı Entegrasyonu</span>
            </a>
        </li> -->

        <li ng-class="{ active: isActive('change-password')}">
            <a href="/change-password">
                <span>Change Password</span>
            </a>
        </li>

        <!-- 
        <li ng-class="{ active: isActive('satin-al')}">
            <a href="/satin-al">
                <i class="fa fa-money"></i>
                <span>Satın Al</span>
            </a>
        </li> -->
    
        <!--         
        <li ng-class="{ active: isActive('webhook')}" ng-if="authenticatedUser.type != 'office'">
            <a href="/webhook">
                <i class="fa fa-key"></i>
                <span>WEBHOOK</span>
            </a>
        </li> -->
    </ul>
         
    <ul class="nav navbar-nav navbar-right" style="width: 58%;">
        <div class="btn-group pull-right" ng-if="isActive(['users'])">
            <a href="#" 
                class="hod-button blue ml10" 
                ng-click="newData()">
                New User
            </a>
        </div>
    </ul>
</header>


<header class="navbar navbar-fixed-top subnavbar bg-system" ng-if="isActive(['users','yeni-yetkili'])">
        
    <ul class="nav navbar-nav navbar-left">
        <input type="text" 
            class="btn btn-operation ml10 text-input" 
            ng-model="data.term" 
            placeholder="By Name">

        <a href="#" 
            class="btn btn-danger btn-rounded btn-sm ml10" 
            ng-click="delete('set')" 
            ng-disabled="deleted.length == 0" 
            ng-if="deleted.length > 0">
            <i class="fa fa-trash"></i> Delete
        </a>
    </ul>
    
</header>